
import { Component, Vue } from 'nuxt-property-decorator'
import scrollBehavior from '~/utils/router.scrollBehaviour'
import TheHeader from '~/components/header/TheHeader.vue'
import { watchResize, Resize, mapDeviceType } from '~/plugins/resize'

@Component<LayoutDefault>({
  components: {
    TheHeader,
  },
})
export default class LayoutDefault extends Vue {
  mounted() {
    this.$resize = mapDeviceType()
    watchResize((type: Resize) => {
      this.$resize = type
    })
    if (this.$route.query.scrollId || this.$route.hash) {
      scrollBehavior(this.$route).then(({ y, selector }) => {
        if (y) {
          window.scrollTo(0, y)
        } else if (selector) {
          const element = document.querySelector(selector)
          const offset = element?.getBoundingClientRect()?.top ?? 0
          window.scrollTo(0, offset)
        }
      })
      window.$nuxt.$nextTick(() => window.$nuxt.$emit('triggerScroll'))
    }
  }
}
